import { hyperevmTokens } from '@pancakeswap/tokens'
import { FeeAmount } from '@pancakeswap/v3-sdk'
import { getAddress } from 'viem'
import { defineFarmV3Configs } from '../src/defineFarmV3Configs'
import { SerializedFarmConfig } from '../src'

export const farmsV3 = defineFarmV3Configs([
  {
    pid: 1,
    lpAddress: '0x2CDd4c39e62db7a30C216de1A243556eB4652264',
    token0: hyperevmTokens.weth,
    token1: hyperevmTokens.usdc,
    feeAmount: FeeAmount.HIGH,
  },
])

const farms: SerializedFarmConfig[] = [
  {
    pid: 1,
    lpSymbol: 'HYPE-USDC LP',
    lpAddress: '0x2CDd4c39e62db7a30C216de1A243556eB4652264',
    token: hyperevmTokens.weth,
    quoteToken: hyperevmTokens.usdc,
  },
].map((p) => ({
  ...p,
  token: p.token.serialize,
  quoteToken: p.quoteToken.serialize,
  lpAddress: getAddress(p.lpAddress),
}))

export default farms
